import React, { Suspense, useEffect } from 'react';
import Routes from './routes/routes';
import setAuthToken from './axiosConfig';
import axios from 'axios';
import { API_RESPONSE_CODES, MAINTENANCE_MODE } from './utills/constant';
import { handleLogout } from './app/auth/slice/authSlice';
import { useDispatch } from 'react-redux';
import Loader from './components/common/Loader';
import MaintenancePage from './components/MaintenancePage';
import useStandaloneExitGuard from './components/common/useStandaloneExitGuard';
import useStandaloneInAppLinks from './components/common/useStandaloneInAppLinks';

setAuthToken();

export default function App() {
  const dispatch = useDispatch();
  useStandaloneExitGuard();
  useStandaloneInAppLinks();

  // Register the 401 handler once (not on every render, which stacked duplicate interceptors)
  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      async function (error) {
        const { response } = error;
        if (response && response.status === API_RESPONSE_CODES?.UNAUTHORIZED) {
          dispatch(handleLogout());
          localStorage.clear();
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptorId);
  }, [dispatch]);

  return (
    <Suspense fallback={<Loader />}>
      {MAINTENANCE_MODE ? <MaintenancePage /> : <Routes />}
    </Suspense>
  );
}
